import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetRecentlySavedReports as GetRecentlySavedReportsQuery,
    GetRecentlySavedReports_recentlySavedReports as RecentlySavedReports,
} from 'nutshell-graphql-types';

import GET_RECENTLY_SAVED_REPORTS from '../queries/get-recently-saved-reports.graphql';

export const useGetRecentlySavedReports = (): {
    recentlySavedReports: RecentlySavedReports[];
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<
        GetRecentlySavedReportsQuery,
        Record<any, any>
    >(GET_RECENTLY_SAVED_REPORTS, {fetchPolicy: 'cache-and-network'});

    return {
        recentlySavedReports: (data && data.recentlySavedReports) || [],
        // Only show loading state if we don't have cached data yet
        isLoading: loading && !data,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
